import {BaseModel} from '../../../shared/models';

export enum PadronDepartamento {
  'Artigas' = 1,
  'Canelones' = 2,
  'Cerro Largo' = 3,
  'Colonia' = 4,
  'Durazno' = 5,
  'Flores' = 6,
  'Florida' = 7,
  'Lavalleja' = 8,
  'Maldonado' = 9,
  'Montevideo' = 10,
  'Paysandu' = 11,
  'Rio Negro' = 12,
  'Rivera' = 13,
  'Rocha' = 14,
  'Salto' = 15,
  'San Jose' = 16,
  'Soriano' = 17,
  'Tacuarembo' = 18,
  'Treinta y Tres' = 19
}

export enum PadronTipo {
  'Rural' = 'R',
  'Urbano' = 'U',
  'Suburbano' = 'S',
}

export class Padron extends BaseModel{
  padronId: string;
  departamentoId: string;
  departamentoNombre: string;
  padronFueSeleccionado: boolean;
  padronArea?: number;
  chacraId?: string;
  padronPropietarioId?: string;
  padronTipo?: string;
  padronLocalidad?: string;
  adjuntoId?: string;
}

export interface Departamento {
  nombre: string;
  id: string;
}

export interface Localidad {
  LocalidadCodigo: number;
  LocalidadNombre: string;
  DepartamentoId: number;
  DepartamentoNombre: string;
}

export interface PadronTipoCore {
  nombre: string;
  id: string;
}

export function getDepartamentos(): Departamento[] {
  const d = Object.keys(PadronDepartamento).filter(key => !isNaN(Number(PadronDepartamento[key])));
  return Object.values(d).map(val => ({ id: PadronDepartamento[val], nombre: val }));
}

export function getPadronTipos(): PadronTipoCore[] {
  return Object.keys(PadronTipo).map(key => ({ id: PadronTipo[key], nombre: key }));
}

export function padronCoreId(p: Padron): string {
  if (!p) {
    return null;
  }
  return `${p.padronId} ${p.departamentoId}`;
}

export function padronCoreText(p: Padron): string {
  if (!p) {
    return null;
  }
  return `${p.departamentoNombre} ${p.padronId} (${p.padronArea} ha)`;
}
